import React, { useEffect, useState } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import './PublicCampRegister.css';

const API = window.location.origin + '/api';

export default function PublicCampRegisterSuccessPage() {
  const { slug } = useParams();
  const [params] = useSearchParams();
  const [status, setStatus] = useState('confirming'); // confirming | confirmed | pending | error

  useEffect(() => {
    document.title = 'Registration Confirmed | ProZpects';
    const sessionId = params.get('session_id');
    if (!sessionId) { setStatus('confirmed'); return; } // no-Stripe path already fulfilled
    axios.post(`${API}/camps/public/confirm`, { session_id: sessionId })
      .then((r) => setStatus(r.data.status === 'confirmed' ? 'confirmed' : 'pending'))
      .catch(() => setStatus('error'));
  }, [slug, params]);

  return (
    <div className="pcr-shell">
      <div className="pcr-card" style={{ textAlign: 'center' }}>
        <img src="/logo-wordmark.png" alt="ProZpects" className="pcr-logo" />
        {status === 'confirming' && <p>Confirming your registration…</p>}
        {status === 'confirmed' && (
          <>
            <h1 className="pcr-hero">You're registered! 🎉</h1>
            <p>Check your email for a link to set your password and finish setting up your ProZpects account.</p>
            <p style={{ color: '#5b6473', fontSize: 14 }}>
              Already have an account? Your camp has been added — just sign in.
            </p>
          </>
        )}
        {status === 'pending' && <p>Your payment is still processing. You'll get a confirmation email shortly.</p>}
        {status === 'error' && <p>We couldn't confirm your registration automatically. Please check your email or contact support.</p>}
      </div>
    </div>
  );
}
